import React, { useState, useEffect } from "react";
import JoinRoomInputs from "./JoinRoomInputs";
import { connect } from "react-redux";
import OnlyWithAudioCheckbox from "./OnlyWithAudioCheckbox";
import {
  setConnectOnlyWithAudio,
  setIdentity,
  setRoomId,
} from "../store/actions";
import ErrorMessage from "./ErrorMessage";
import JoinRoomButtons from "./JoinRoomButtons";
import { useHistory, useLocation } from "react-router-dom";
import { getRoomExists } from "../utils/api";

const JoinRoomContent = (props) => {
  const {
    isRoomHost,
    setConnectOnlyWithAudio,
    connectOnlyWithAudio,
    setIdentityAction,
    setRoomIdAction,
    roomId,
  } = props;

  const [roomIdValue, setRoomIdValue] = useState("");
  const [username, setNameValue] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);

  const history = useHistory();
  const location = useLocation();
  const search = useLocation().search;

  useEffect(() => {
    // Extract roomId from URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const idFromUrl = queryParams.get("id");
    const isHostUser = new URLSearchParams(search).get("user");
    const username1 = new URLSearchParams(search).get("username");

    const effectiveRoomId = idFromUrl;

    setNameValue(username1);
    if (isRoomHost === true && isHostUser && idFromUrl) {
      setRoomIdValue(idFromUrl);
      createRoom();
    } else if (isRoomHost === true) {
      // Automatically create and start the meeting if the user is a host
      createRoom();
    }
    else if (effectiveRoomId) {
      setRoomIdValue(idFromUrl); // Set roomId from the URL
    }
    else if (effectiveRoomId) {
      // Automatically join the room if roomId is provided in the URL
      // joinRoom(idFromUrl);
    }
  }, [isRoomHost, location.search]); // Trigger this effect when isRoomHost or location.search changes

  const handleJoinRoom = async () => {
    if (!username || username.trim() === "") {
      setErrorMessage("Please enter your name.");
      return; // Stop further execution if name is blank
    }
    setErrorMessage(null); // Clear any previous errors

    setIdentityAction(username);
    if (isRoomHost === true) {
      createRoom();
    } else {
      await joinRoom(roomIdValue);
    }
  };


  const joinRoom = async (id) => {
    const roomToJoin = id || roomIdValue; // Use the provided ID or fall back to roomIdValue
    const responseMessage = await getRoomExists(roomToJoin);

    const { roomExists, full } = responseMessage;

    if (roomExists) {
      if (full) {
        setErrorMessage("Meeting is full. Please try again later.");
      } else {
        // Join the room
        setRoomIdAction(roomToJoin);
        history.push("/room");
      }
    } else {
      setErrorMessage("Meeting not found. Check your meeting ID.");
    }
  };


  const createRoom = () => {
    const generatedRoomId = roomIdValue || generateRandomRoomId();
    setIdentityAction(username || "Host");
    setRoomIdAction(generatedRoomId);

    history.push("/room"); // Redirect to the room
  };


  const generateRandomRoomId = () => {
    // const rmn = Math.random().toString(36).substring(2, 10);
    // // console.log(rmn)
    // return rmn; // Simple random room ID generator
    return makeid(9);
  };

  function makeid(length) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
      if ((i + 1) % 3 === 0 && i + 1 !== length) {
        result += "-";
      }
    }
    return result;
  }

  return (
    <>
      {!isRoomHost && (
        <JoinRoomInputs
          roomIdValue={roomIdValue}
          setRoomIdValue={setRoomIdValue}
          nameValue={username}
          setNameValue={setNameValue}
          isRoomHost={isRoomHost}
        />
      )}
      {/* <OnlyWithAudioCheckbox
        setConnectOnlyWithAudio={setConnectOnlyWithAudio}
        connectOnlyWithAudio={connectOnlyWithAudio}
      /> */}
      <ErrorMessage errorMessage={errorMessage} />
      {!isRoomHost && (
        <JoinRoomButtons
          handleJoinRoom={handleJoinRoom}
          isRoomHost={isRoomHost}
          disableJoin={!username || username.trim() === ""}
        />
      )}
    </>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

const mapActionsToProps = (dispatch) => {
  return {
    setConnectOnlyWithAudio: (onlyWithAudio) =>
      dispatch(setConnectOnlyWithAudio(onlyWithAudio)),
    setIdentityAction: (identity) => dispatch(setIdentity(identity)),
    setRoomIdAction: (roomId) => dispatch(setRoomId(roomId)),
  };
};

export default connect(mapStoreStateToProps, mapActionsToProps)(JoinRoomContent);
